import TopSection from './TopSection'
import ReasonsSection from './ReasonsSection'
import VideoSection from './VideoSection'
import TestimonialsSection from './TestimonialsSection'
import FeatureSection from './FeatureSection'

const Home = () => {
  return (
    <div>
      <TopSection />
      <FeatureSection />
      <ReasonsSection />
      <VideoSection />
      <TestimonialsSection />
    </div>
  )
}

export default Home
